import type {
  SavingsReportingAccount,
  SavingsReportingDeposit,
  SavingsReportingHub
} from '@/interfaces/SavingsReporting.interface';
import BaseApiClient from '../BaseApiClient';
import {
  SAVINGS_API_VERSION_HEADERS,
  toSavingsListResponse
} from '../savings-reference-resource';
import type { ListDataParams, ListDataResponse } from '../types';

export class ApiSavingsReporting extends BaseApiClient {
  private async list<T>(
    path: string,
    listData: ListDataParams
  ): Promise<ListDataResponse<T>> {
    const res = await this.client.getList(path, listData, {
      headers: SAVINGS_API_VERSION_HEADERS
    });

    return toSavingsListResponse<T>(res.data);
  }

  listAccounts(
    listData: ListDataParams
  ): Promise<ListDataResponse<SavingsReportingAccount>> {
    return this.list('/reporting/all-accounts', listData);
  }

  listHubs(
    listData: ListDataParams
  ): Promise<ListDataResponse<SavingsReportingHub>> {
    return this.list('/reporting/all-hubs', listData);
  }

  listDeposits(
    listData: ListDataParams
  ): Promise<ListDataResponse<SavingsReportingDeposit>> {
    return this.list('/reporting/all-deposits', listData);
  }
}
